import React from "react";
import { Desktop, Mobile } from "@edreamsodigeo/frontend-core";
import SupportAreaValuePropositionDesktop from "./SupportAreaValuePropositionDesktop";
import SupportAreaValuePropositionMobile from "./SupportAreaValuePropositionMobile";
const SupportAreaValueProposition = () => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Mobile, null, /*#__PURE__*/React.createElement(SupportAreaValuePropositionMobile, null)), /*#__PURE__*/React.createElement(Desktop, null, /*#__PURE__*/React.createElement(SupportAreaValuePropositionDesktop, null)));
};
export default SupportAreaValueProposition;